import * as XLSX from 'xlsx';
import { GeneratedList } from '../pages/home/page';

const TYPE_META: Record<string, { label: string; labelPlural: string }> = {
  individual: { label: 'Individual', labelPlural: 'Individuales' },
  dupla: { label: 'Dupla', labelPlural: 'Duplas' },
  trio: { label: 'Trío', labelPlural: 'Tríos' },
};

function buildSheet(wsData: (string | number)[][]) {
  const ws = XLSX.utils.aoa_to_sheet(wsData);
  const colWidths = wsData[0].map((_, colIndex) => ({
    wch: Math.max(...wsData.map((row) => String(row[colIndex] ?? '').length), 8) + 2,
  }));
  ws['!cols'] = colWidths;
  return ws;
}

function getHeaders(type: string): string[] {
  const base = ['N°', 'Jugador 1'];
  if (type === 'dupla' || type === 'trio') base.push('Jugador 2');
  if (type === 'trio') base.push('Jugador 3');
  base.push('Club', 'Categoría');
  return base;
}

function buildRow(
  player: { jugador1: string; jugador2: string; jugador3: string; club: string; categoria: string },
  idx: number,
  type: string
): (string | number)[] {
  const row: (string | number)[] = [idx + 1, player.jugador1];
  if (type === 'dupla' || type === 'trio') row.push(player.jugador2);
  if (type === 'trio') row.push(player.jugador3);
  row.push(player.club, player.categoria);
  return row;
}

export function generateExcelWorkbook(lists: GeneratedList[]): XLSX.WorkBook {
  const wb = XLSX.utils.book_new();
  const totalGroups = lists.reduce((a, l) => a + l.players.length, 0);

  // Hoja resumen
  const summaryData: (string | number)[][] = [
    ['Resumen de Listas Generadas'],
    ['Total de listas', lists.length],
    ['Total de registros', totalGroups],
    [],
    ['Lista', 'Tipo', 'Cantidad'],
    ...lists.map((l) => {
      const meta = TYPE_META[l.type];
      return [`Lista ${l.listNumber}`, meta.label, l.players.length];
    }),
  ];
  XLSX.utils.book_append_sheet(wb, buildSheet(summaryData), 'Resumen');

  lists.forEach((list) => {
    const meta = TYPE_META[list.type];
    const wsData: (string | number)[][] = [
      [`${meta.labelPlural} – Lista ${list.listNumber}`],
      getHeaders(list.type),
      ...list.players.map((p, i) => buildRow(p, i, list.type)),
    ];
    const sheetName = `${meta.label.substring(0, 4)} ${list.listNumber}`;
    XLSX.utils.book_append_sheet(wb, buildSheet(wsData), sheetName);
  });

  return wb;
}

export function downloadListsAsExcel(lists: GeneratedList[], filename?: string): void {
  const wb = generateExcelWorkbook(lists);
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' }) as ArrayBuffer;
  const blob = new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename ?? `listas_generadas_${Date.now()}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
